import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LOCAL_VAR } from './../constants';
import { LocalStorageService } from '@app/core/local-storage.service';
// import { USER_TYPES } from '@app/core/constants';
var credentialsKey = LOCAL_VAR.credentialsKey;
var selectedAgentKey = LOCAL_VAR.selectedAgent;
/**
 * Provides a base for authentication workflow.
 * The Credentials interface as well as login/logout methods should be replaced with proper implementation.
 */
var AuthenticationService = /** @class */ (function () {
    // private _merchants: Authentication.Merchant | null;
    function AuthenticationService(httpClient, localStorageService) {
        this.httpClient = httpClient;
        this.localStorageService = localStorageService;
        this.merchant$ = new EventEmitter();
        this.credentials$ = new EventEmitter();
        this._liveMode = false;
        this.liveMode$ = new EventEmitter();
        var savedCredentials = this.localStorageService.getItem(credentialsKey);
        if (savedCredentials) {
            this._credentials = JSON.parse(savedCredentials);
        }
        /*** Set new merchant in existing merchants ***/
        if (this.isAuthenticated()) {
            // this.refresh();
        }
    }
    AuthenticationService.prototype.refresh = function () {
        var _this = this;
        setTimeout(function () {
            _this.me().subscribe(function (user) {
                _this._credentials.user = user;
                _this.setCredentials(_this._credentials);
            }, function (error) {
                console.log("get merchants error: " + error);
            });
        }, 1);
    };
    AuthenticationService.prototype.me = function () {
        return this.httpClient.get('/auth/me').pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.login = function (payload) {
        var _this = this;
        return this.httpClient.post('/auth/login', payload).pipe(map(function (body) {
            // OTP challenge — do not store session credentials yet
            if (body && body.otp === 1) {
                return body;
            }
            _this.setCredentials(body);
            return body;
        }));
    };
    AuthenticationService.prototype.verifyLoginOtp = function (payload) {
        var _this = this;
        return this.httpClient.post('/auth/login', payload).pipe(map(function (body) {
            _this.setCredentials(body);
            return body;
        }));
    };
    AuthenticationService.prototype.resendLoginOtp = function (payload) {
        return this.httpClient.post('/auth/resendotp', payload).pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.setPassword = function (payload) {
        return this.httpClient.post('/auth/activation', payload).pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.forgotPassword = function (payload) {
        return this.httpClient.post('/auth/forgotpassword', payload).pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.resetPassword = function (payload) {
        return this.httpClient.post('/auth/updatepassword', payload).pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.signup = function (payload) {
        return this.httpClient.post('/signup', payload).pipe(map(function (body) {
            return body;
        }));
    };
    AuthenticationService.prototype.verifyEmail = function (emailHash) {
        return this.httpClient.get("/verifyEmail?emailHash=" + emailHash).pipe(map(function (body) {
            return body;
        }));
    };
    /**
     * Logs out the user and clear credentials.
     * @return {Observable<boolean>} True if the user was logged out successfully.
     */
    AuthenticationService.prototype.logout = function (flag) {
        var _this = this;
        if (flag) {
            this.setCredentials();
            return of(true);
        }
        else {
            return this.httpClient
                .post('/logout', {
                sessionId: this.credentials.session
            })
                .pipe(map(function () {
                _this.setCredentials();
                return true;
            }));
        }
    };
    /**
     * Checks is the user is authenticated.
     * @return {boolean} True if the user is authenticated.
     */
    AuthenticationService.prototype.isAuthenticated = function () {
        return !!this.credentials;
    };
    AuthenticationService.prototype.uploadPhoto = function (payload) {
        return this.httpClient.put('/auth/uploadFile', payload).pipe(map(function (body) {
            return body;
        }));
    };
    Object.defineProperty(AuthenticationService.prototype, "credentials", {
        /**
         * Gets the user credentials.
         * @return {Credentials} The user credentials or null if the user is not authenticated.
         */
        get: function () {
            return this._credentials;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "accessToken", {
        /**
         * Get the auth token.
         * @return {string} The auth token is null if user is not authenticated.
         */
        get: function () {
            return this.credentials ? this.credentials.accessToken : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "merchant", {
        /**
         * Get the auth token.
         * @return {string} The auth token is null if user is not authenticated.
         */
        get: function () {
            return this._merchant ? this._merchant : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "sessionId", {
        /**
         * Get the auth token.
         * @return {string} The auth token is null if user is not authenticated.
         */
        get: function () {
            return this.credentials ? this.credentials.session : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the user credentials.
     * @param {Credentials=} Authentication.Credentials The user credentials.
     */
    AuthenticationService.prototype.setCredentials = function (credentials) {
        this._credentials = credentials || null;
        if (credentials) {
            this.localStorageService.setItem(credentialsKey, JSON.stringify(credentials));
            this.credentials$.emit(this._credentials);
            if (this.credentials.user.userRoleId.slug === 'agentuser' &&
                this.credentials.user.userId !== undefined) {
                this.localStorageService.setItem(selectedAgentKey, JSON.stringify(this.credentials.user.agentData));
            }
            else if (this.credentials.user.userRoleId.slug !== 'admin') {
                this.localStorageService.setItem(selectedAgentKey, JSON.stringify(this.credentials.user));
            }
        }
        else {
            this.localStorageService.clearItem(credentialsKey);
        }
    };
    Object.defineProperty(AuthenticationService.prototype, "liveMode", {
        /**
         * Get Live mode value
         * @return {boolean} True if livemode enabled
         */
        get: function () {
            return this._liveMode;
        },
        /**
         * Set Live mode value
         * @liveMode {boolean}
         */
        set: function (liveMode) {
            this._liveMode = liveMode;
            this.liveMode$.emit(this.liveMode);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "loggedInUserType", {
        get: function () {
            if (this.credentials &&
                this.credentials.user &&
                this.credentials.user.userRoleId &&
                this.credentials.user.userRoleId.slug) {
                return this.credentials.user.userRoleId.slug;
            }
            else {
                return '';
            }
        },
        enumerable: true,
        configurable: true
    });
    return AuthenticationService;
}());
export { AuthenticationService };
